import { MoreHorizontal24Regular } from '@fluentui/react-icons';
import { Button } from '../Button/Button';
import { Input } from '../Input/Input';
import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { VirtualizedTableColType } from './VirtualizedTable.interface';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export interface VirtualizedEditableCellProps {
  columnType: VirtualizedTableColType;
  onEditCellChange: (value: string) => void;
  onMultiSelectionClick?: () => void;
  value: string | ReactNode;
  focus?: boolean;
}

export const VirtualizedEditableCell: FC<VirtualizedEditableCellProps> = ({
  columnType,
  onEditCellChange,
  onMultiSelectionClick,
  value,
  focus,
}) => {
  const { t } = useTranslation();
  const inputReference = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focus) {
      inputReference.current?.focus();
    }
  }, [focus]);

  return (
    <>
      {(columnType === VirtualizedTableColType.Number ||
        columnType === VirtualizedTableColType.String) && (
        <Input
          ref={inputReference}
          className="editable-cell-input-string w-full"
          value={value as string}
          onChange={(_, data) => onEditCellChange(data.value)}
          aria-label={t('table_editable_column_text_input_label', { defaultValue: 'Text kann bearbeitet werden' })}
        />
      )}
      {columnType === VirtualizedTableColType.Date && (
        <Input
          className="editable-cell-input-date w-full"
          value={moment(value as string).format('YYYY-MM-DD')}
          onChange={(_, data) => onEditCellChange(data.value)}
          type="date"
          aria-label={t('table_editable_column_date_input_label', { defaultValue: 'Datum kann bearbeitet werden' })}
        />
      )}
      {columnType === VirtualizedTableColType.Mulitselect && (
        <Button
          appearance="transparent"
          className="editable-cell-input-multiselect"
          iconPosition="after"
          icon={<MoreHorizontal24Regular />}
          onClick={onMultiSelectionClick}
        >
          {value}
        </Button>
      )}
    </>
  );
};
